import { customizeCaption } from './customizeCaption';
import { trimHashtagSpaces } from './trimHashTagSpaces';

export const prepareHashtags = (captionSettings: any, hashtags: string) => {
	const customizedHashtags =
		hashtags && customizeCaption(captionSettings, hashtags);
	return customizedHashtags && trimHashtagSpaces(customizedHashtags);
};
